/* eslint-disable no-restricted-globals */
const getGlobalThis = () => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof window !== 'undefined') return window
  if (typeof self !== 'undefined') return self
  if (typeof global !== 'undefined') return global

  return (function getThis(this: any) {
    return this
  })()
}
/* eslint-enable no-restricted-globals */

export const globalObject = getGlobalThis()
